<div class="n-list-component-header">
  <h2>List of projects</h2>
  <div>
    <!-- <button matIconButton matTooltip="Here comes the info"><mat-icon>info</mat-icon></button> -->
    <button matIconButton matTooltip="Select columns"
      (click)="openColumnSelector()"><mat-icon>view_column</mat-icon></button>
  </div>
</div>

<form [formGroup]="filterForm" class="n-filters-form">
  <div>
    <mat-expansion-panel [(expanded)]="filtersExpanded" #filtersPanel style="margin: 5px 0px; flex-grow: 1; ">
      <mat-expansion-panel-header>
        <mat-panel-title><mat-icon>search</mat-icon> Filters </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="n-filter-form-row" style="align-items: flex-start">
        <div class="n-select-filter-field-column">
          <mat-form-field class="n-search-field" style="width: 100%">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput placeholder="Name filter" #simpleFilterInput formControlName="textFilter">
          </mat-form-field>

        </div>
        <div class="n-select-filter-field-column">
          <mat-form-field class="n-search-field" style="width: 100%">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [formGroup]="activeRange" [rangePicker]="activeRangePicker">
              <input matStartDate formControlName="start" placeholder="Start date">
              <input matEndDate formControlName="end" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="activeRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #activeRangePicker></mat-date-range-picker>

            @if (activeRange.controls['start'].hasError('matStartDateInvalid')) {
            <mat-error>Invalid start date</mat-error>
            }
            @if (activeRange.controls['end'].hasError('matEndDateInvalid')) {
            <mat-error>Invalid end date</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="n-select-filter-field-column">
          <app-advanced-select #euficRolesSelect formControlName="euficRoles" [resetTrigger]="resetCounter"
            class="n-search-field n-filter-flex-unit" label="Roles" [options]="allProjectRoleOptions"
            [showAllOrAny]="showAllOrAny()" />
        </div>
        <div class="n-select-filter-field-column">
          <app-advanced-select #topicsSelect formControlName="topics" [resetTrigger]="resetCounter"
            class="n-search-field n-filter-flex-unit" label="Topics of interest" [options]="allTopicOptions()"
            [showAllOrAny]="showAllOrAny()" />
        </div>
        <button matFab (click)="clearAllFilters()" class="n-filter-reset-button"
          matTooltip="Clear all filters"><mat-icon>clear</mat-icon></button>
      </div>
    </mat-expansion-panel>
  </div>
</form>

<div class="n-table-wrapper">
  @if (loading) {
  <div class="n-spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
  }

  <div class="n-table-scroll">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="valid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Is data valid?"><mat-icon>check</mat-icon>
        </th>
        <td mat-cell *matCellDef="let project">
          @if (project.validityStatus() === ValidityStatus.INVALID) {
          <span class="material-symbols-outlined n-invalid-status"
            matTooltip="Record is missing required data">error</span>
          } @else if (project.validityStatus() === ValidityStatus.INCOMPLETE) {
          <span class="material-symbols-outlined n-incomplete-status"
            matTooltip="Record is missing important data">warning</span>
          } @else if (project.validityStatus() === ValidityStatus.VALID) {
          <span class="material-symbols-outlined n-valid-status" matTooltip="Record is valid">verified</span>
          } @else {
          <span class="material-symbols-outlined">cruelty_free</span>
          }
        </td>
      </ng-container>

      <!-- Short Name Column -->
      <ng-container matColumnDef="shortName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Short name</th>
        <td mat-cell *matCellDef="let project" matTooltip="{{ project.fullName }}">{{ project.name }}</td>
      </ng-container>


      <!-- Full Name Column -->
      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Full name</th>
        <td mat-cell *matCellDef="let project" matTooltip="{{ project.fullName }}">{{ project.fullName }}</td>
      </ng-container>

      <!-- Start Date Column -->
      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Start date</th>
        <td mat-cell *matCellDef="let project">{{ project.startDate | date: 'dd/MM/yyyy'}}</td>
      </ng-container>

      <!-- End Date Column -->
      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>End date</th>
        <td mat-cell *matCellDef="let project">{{ project.endDate | date: 'dd/MM/yyyy'}}</td>
      </ng-container>

      <!-- EUFIC Role Column -->
      <ng-container matColumnDef="euficRole">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>EUFIC Role</th>
        <td mat-cell *matCellDef="let project">{{ project.euficRole }}</td>
      </ng-container>

      <ng-container matColumnDef="website">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Website</th>
        <td mat-cell *matCellDef="let project" matTooltip="{{ project.website }}"><span>{{ project.website }}</span>
        </td>
      </ng-container>

      <!-- Topics of interest Column -->
      <ng-container matColumnDef="topics">
        <th mat-header-cell *matHeaderCellDef>Topics of interest</th>
        <td mat-cell *matCellDef="let project">
          <mat-chip-set class="n-my-chip">
            @for (topic of project.topics; track topic.id) {
            <mat-chip><span matTooltip="{{topic.name}}">{{ topic.name }}</span></mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- Event Types Column -->
      <ng-container matColumnDef="targetAudiences">
        <th mat-header-cell *matHeaderCellDef>Target audiences</th>
        <td mat-cell *matCellDef="let project">
          <mat-chip-set class="n-my-chip">
            @for (a of project.targetAudiences; track a.id) {
            <mat-chip><span matTooltip="{{a.name}}">{{ a.name }}</span></mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>

      <ng-container matColumnDef="areasOfWork">
        <th mat-header-cell *matHeaderCellDef>Areas of work</th>
        <td mat-cell *matCellDef="let project">
          <mat-chip-set class="n-my-chip">
            @for (a of project.areasOfWork; track a.id) {
            <mat-chip><span matTooltip="{{a.name}}">{{ a.name }}</span></mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>

      <ng-container matColumnDef="fundingSchemes">
        <th mat-header-cell *matHeaderCellDef>Funding schemes</th>
        <td mat-cell *matCellDef="let project">
          <mat-chip-set class="n-my-chip">
            @for (a of project.fundingSchemes; track a.id) {
            <mat-chip><span matTooltip="{{a.name}}">{{ a.name }}</span></mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- lastModifiedOn Column -->
      <ng-container matColumnDef="lastModifiedOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last modification</th>
        <td mat-cell *matCellDef="let project">
          {{ project.lastModifiedOn | date:'dd/MM/yyyy HH:mm' }}
        </td>
      </ng-container>

      <tr mat-header-row class="n-header-row" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="n-data-row" (click)="goToDetail(row)"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data matching the filter</td>
      </tr>
    </table>
  </div>
</div>
<mat-paginator #paginator class="demo-paginator" showFirstLastButtons="true" hidePageSize="false"
  [pageSizeOptions]="[5,10,25]" aria-label="Select page">
</mat-paginator>

<div class="n-button-row">
  <button matFab extended class="n-save-button" (click)="add()"><mat-icon>add</mat-icon> Add project</button>
  <!-- <button matFab extended class="n-export-button" (click)="export()"><mat-icon>file_download</mat-icon>Export
    list</button> -->
</div>